/* GDP 18/10/2026 · Réservation du Miel Blanc (snippets/gdp-blanc-retour.liquid → gdp-resa-ui.liquid).
   Compte à rebours de la mise en pot (une mise à jour par seconde, en pause quand l'onglet est caché), bascule de l'état A
   à l'état B quand il atteint zéro (sans recharger, sans jamais revenir en arrière), lien « Soyez prévenu » de l'état C
   (inscription à la newsletter du pied de page, avec une étiquette dédiée). Aucune dépendance. */
(function () {
  'use strict';
  if (window.__gdpResa) return;
  window.__gdpResa = 1;
  var timer = 0, done = false;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function endOf() {
    var e = document.querySelector('[data-gdp-resa-end]');
    return e ? Number(e.getAttribute('data-gdp-resa-end')) || 0 : 0;
  }
  function toB() {
    if (done) return;
    done = true;
    window.__gdpResaB = true;
    if (timer) { clearInterval(timer); timer = 0; }
    var i, l = document.querySelectorAll('[data-gdp-resa-v="a"]');
    for (i = 0; i < l.length; i++) l[i].hidden = true;
    l = document.querySelectorAll('[data-gdp-resa-v="b"]');
    for (i = 0; i < l.length; i++) l[i].hidden = false;
    /* Bouton d'origine : libellés « Réserver… » remplacés par ceux de la vente immédiate. */
    l = document.querySelectorAll('input[data-cta-label-b]');
    for (i = 0; i < l.length; i++) l[i].setAttribute('data-cta-label', l[i].getAttribute('data-cta-label-b'));
    var c = document.querySelector('input[name="gdp-tier"]:checked[data-cta-label-b]');
    var ml = document.querySelector('[data-gdp-pdp-main-label]');
    if (c && ml) ml.textContent = c.getAttribute('data-cta-label-b');
    /* v4 (18/10) : libellés habituels du bas de fiche (accord miel + amandes : data-label-b ; rappel des avis : data-gdp-resa-txt-b). */
    l = document.querySelectorAll('[data-label-b]');
    for (i = 0; i < l.length; i++) l[i].setAttribute('data-label', l[i].getAttribute('data-label-b'));
    l = document.querySelectorAll('[data-gdp-resa-txt-b]');
    for (i = 0; i < l.length; i++) l[i].textContent = l[i].getAttribute('data-gdp-resa-txt-b');
    try { document.dispatchEvent(new CustomEvent('gdp:resa:b')); } catch (e) {}
  }
  function paint(now) {
    var l = document.querySelectorAll('[data-gdp-resa-cd][data-end]');
    for (var i = 0; i < l.length; i++) {
      var el = l[i];
      /* bouton d'origine masqué par les deux boutons : rien à peindre (évite de réveiller ses observateurs) */
      if (el.closest('.gdp-dcta-on [data-gdp-pdp-main-cta]')) continue;
      var d = Number(el.getAttribute('data-end')) - now;
      if (!(d > 0)) continue;
      var u = (el.getAttribute('data-u') || 'j|h|min|s').split('|');
      var s = Math.floor(d / 1000), D = Math.floor(s / 86400), H = Math.floor(s % 86400 / 3600), M = Math.floor(s % 3600 / 60), S = s % 60;
      var t = el.querySelector('[data-t]'), z = el.querySelector('[data-s]'), txt;
      if (el.getAttribute('data-f') === 'm') {
        txt = D > 0 ? D + ' ' + u[0] + ' ' + H + ' ' + u[1] : H + ' ' + u[1] + ' ' + pad(M) + ' ' + u[2];
        if (t && t.textContent !== txt) t.textContent = txt;
      } else {
        txt = (D > 99 ? D : pad(D)) + ' ' + u[0] + ' ' + pad(H) + ' ' + u[1] + ' ' + pad(M) + ' ' + u[2];
        if (t && t.textContent !== txt) t.textContent = txt;
        if (z) z.textContent = pad(S) + ' ' + u[3];
      }
    }
  }
  function tick() {
    var end = endOf();
    if (!end) { if (timer) { clearInterval(timer); timer = 0; } return; }
    var now = Date.now();
    if (now >= end) { toB(); return; }
    paint(now);
  }
  function start() { if (done || timer || document.hidden) return; tick(); if (!done) timer = setInterval(tick, 1000); }
  function stop() { if (timer) { clearInterval(timer); timer = 0; } }
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  /* Jauge sous chaque bouton (18/10/2026) : à l'apparition à l'écran, le chiffre compte de 0 à N et la règle se remplit, une seule fois par jauge
     (rien si mouvement réduit, ni si elle est déjà à l'écran au chargement : elle reste alors fixe, chiffre final). Les jauges clonées sous les boutons de
     formule arrivent après le chargement : gdp-tier-dual-cta lance l'évènement gdp:resa:meters. Une jauge « en attente » est toujours libérée au bout de 10 s. */
  function count(m) {
    var l = m.querySelectorAll('[data-n]');
    for (var i = 0; i < l.length; i++) (function (e) {
      var to = Number(e.getAttribute('data-n')) || 0, t0 = null;
      function f(t) {
        if (t0 === null) t0 = t;
        var p = Math.min(1, (t - t0) / 1100);
        e.textContent = p < 1 ? Math.round(to * (1 - Math.pow(1 - p, 3))) : to;
        if (p < 1) requestAnimationFrame(f);
      }
      requestAnimationFrame(f);
    })(l[i]);
  }
  function release(m, io) {
    if (!m.classList.contains('is-wait')) return;
    if (io) io.unobserve(m);
    requestAnimationFrame(function () { requestAnimationFrame(function () { m.classList.remove('is-wait'); count(m); }); });
  }
  function meters() {
    var l = document.querySelectorAll('[data-gdp-resa-meter]:not([data-gdp-resa-seen])');
    if (!l.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) release(x.target, io); });
    }, { threshold: 0.6 });
    for (var i = 0; i < l.length; i++) {
      var m = l[i], r = m.getBoundingClientRect();
      m.setAttribute('data-gdp-resa-seen', '');
      if (r.top < window.innerHeight && r.bottom > 0) continue;
      m.classList.add('is-wait');
      var n = m.querySelectorAll('[data-n]');
      for (var j = 0; j < n.length; j++) n[j].textContent = '0';
      io.observe(m);
      setTimeout((function (el) { return function () {
        var q = el.getBoundingClientRect();
        if (q.height && q.top < window.innerHeight && q.bottom > 0) release(el, io);
      }; })(m), 10000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', meters); else meters();
  document.addEventListener('gdp:resa:meters', meters);

  /* v5 (18/10) : « Réservez votre Miel Blanc dès maintenant ↓ » → défilement doux jusqu'aux formules, juste sous l'en-tête collant
     (sans JS, l'ancre #gdp-resa-formules et son scroll-margin-top font le même travail, sans douceur). */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-gdp-resa-go]');
    if (!a) return;
    var an = document.getElementById('gdp-resa-formules');
    if (!an) return;
    var t = an.nextElementSibling;
    while (t && (t.tagName === 'SCRIPT' || t.tagName === 'STYLE' || !t.getBoundingClientRect().height)) t = t.nextElementSibling;
    if (!t) t = an;
    e.preventDefault();
    var h = document.querySelector('header'), off = 12;
    if (h) { var hb = h.getBoundingClientRect(), hp = getComputedStyle(h).position; if ((hp === 'sticky' || hp === 'fixed') && hb.bottom > 0) off += hb.height; }
    var y = Math.max(0, t.getBoundingClientRect().top + window.pageYOffset - off);
    var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try { window.scrollTo({ top: y, behavior: rm ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, y); }
  });

  /* État C : « Soyez prévenu en premier de la prochaine mise en pot » → formulaire newsletter du pied de page. */
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('[data-gdp-resa-notify]');
    if (!a) return;
    var f = document.querySelector('.gdp-footer__newsletter-form') || document.querySelector('form[id^="newsletter-form"]');
    if (!f) return;
    e.preventDefault();
    var tg = f.querySelector('input[name="contact[tags]"]');
    if (tg && tg.value.indexOf('prochaine-mise-en-pot-miel-blanc') < 0) tg.value = (tg.value ? tg.value + ',' : '') + 'prochaine-mise-en-pot-miel-blanc';
    try { f.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (err) { f.scrollIntoView(); }
    var em = f.querySelector('input[type="email"]');
    if (em) setTimeout(function () { try { em.focus({ preventScroll: true }); } catch (err) { em.focus(); } }, 600);
  });
})();
